import Button from "../Button/Button";

export default function PopupFooter({
  cancelbtn,
  savebtn,
  CancelClick,
  savebtnClick,
}) {
  return (
    <>
      <Button
        type="primary"
        text={savebtn}
        htmlType="submit"
        onClick={savebtnClick ? savebtnClick : undefined}
      />
      {cancelbtn && (
        <>
          <Button
            type={"default"}
            htmlType="button"
            text={cancelbtn}
            onClick={CancelClick}
          />
        </>
      )}
    </>
  );
}
